import { MenuItem, Select } from "@mui/material";
import React from "react";
import { useLanguage } from "../contexts/Language";
import LanguageFlag from "./LanguageFlag";

function LanguageSelect() {
  // Contexts
  const { languageCode, switchLanguage, supportedLanguages } = useLanguage();

  // Render
  return (
    <Select
      variant="standard"
      value={languageCode}
      defaultValue="en"
      onChange={(event) => switchLanguage(event.target.value)}
      label="Language"
      disableUnderline
      sx={{ "& .MuiInputBase-input": { height: "16px", minHeight: 1 } }} // TODO center vertically
    >
      {Object.keys(supportedLanguages).map((supportedLanguageCode) => (
        <MenuItem key={supportedLanguageCode} value={supportedLanguageCode}>
          <LanguageFlag languageCode={supportedLanguageCode} />
          {/* {supportedLanguages[supportedLanguageCode]} */}
        </MenuItem>
      ))}
    </Select>
  );
}

export default LanguageSelect;
